class RenewTokenInterceptor {
    response(response) {
        RenewTokenInterceptor.store(response.headers('new-jwt'))
        return response
    }

    context(context) {
        if (context && context.response && context.response.headers) {
            const headers = context.response.headers
            RenewTokenInterceptor.store(headers.get('new-jwt'))
        }
    }

    static store(jwt) {
        if (jwt) {
            localStorage.setItem('jwt', jwt)
        }
    }
}

angular.module('eficienciaFiscalModule')
    .service('renewTokenInterceptor', [RenewTokenInterceptor])
    .config(['$httpProvider', function($httpProvider) {
        $httpProvider.interceptors.push('renewTokenInterceptor');
    }]);
